import CustomError from './CustomError'

export default class InvalidOtpException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
